import React from 'react'

function YouTubeIcon({
    className,
    width = "31",
    height = "22",
    fill = "black"
}) {
    return (
        <svg className={className} width={width} height={height} viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.353 3.43662C30.1765 2.77115 29.8305 2.16428 29.3497 1.67675C28.8688 1.18922 28.2698 0.83812 27.6128 0.658599C25.1944 1.33636e-07 15.5 0 15.5 0C15.5 0 5.80558 -1.33636e-07 3.38716 0.655095C2.72987 0.834035 2.13064 1.18494 1.64966 1.67256C1.16868 2.16018 0.822881 2.76736 0.646986 3.43312C-1.31982e-07 5.88535 0 11 0 11C0 11 -1.31982e-07 16.1147 0.646986 18.5634C1.00335 19.9156 2.05513 20.9806 3.38716 21.3414C5.80558 22 15.5 22 15.5 22C15.5 22 25.1944 22 27.6128 21.3414C28.9483 20.9806 29.9967 19.9156 30.353 18.5634C31 16.1147 31 11 31 11C31 11 31 5.88535 30.353 3.43662ZM12.4208 15.6943V6.30573L20.4475 10.965L12.4208 15.6943Z" fill={fill} />
        </svg>
    )
}

export default YouTubeIcon